import { ImagineChatError } from "@imagine/ai-service/shared-types";

const isImagineChatError = (error: Error) => {
  return error.message.includes("ImagineChatError");
};

const sanitizeChatError = (error: Error) => {
  if (isImagineChatError(error)) {
    const parsedError = JSON.parse(error.message) as ImagineChatError;
    return {
      title: parsedError.message ?? "An unknown error occurred",
      retriable: parsedError.retriable ?? true,
      traceId: parsedError.traceId,
    };
  } else {
    return {
      title: error.message ?? "An unknown error occurred",
      retriable: true,
      traceId: undefined,
    };
  }
};

export const errorHandling = {
  isImagineChatError,
  sanitizeChatError,
};
